import config from "appConfig";
import {
  isAllowedValue,
  joinWithTwoSeparators,
  formatDate,
  formatNumber
} from "./utils";
import { DetailGroupType, DetailValueType, emptyUUID } from "../models/enums";
import { AttributeI, MultiLevelFieldChildI } from "./multiLevelTypes";
import { ControlChildI, CommonDataI } from "../typings/routesTypes";
import { notRegistredOption } from "../components/FormControls/RegistrationSelect/RegistrationSelect";

export const getMultiLevelField = (
  child: ControlChildI | CommonDataI,
  fields: string[]
) => {
  if (child.child) {
    getMultiLevelField(child.child, fields);
  }

  fields.push(child.field);
};

export const getAllMultiLevelField = (
  child: MultiLevelFieldChildI | ControlChildI,
  fields: string[]
) => {
  if (child.child) {
    getAllMultiLevelField(child.child, fields);
  }

  fields.push(child.field);
  fields.push(child.excludedField);
};

// Ad detail responses carry the human readable value of every multi level id
// next to the id itself: makeId -> makeName, categoryLv1Id -> categoryLv1Name, ...
export const multiLevelNameField = (field: string) => field.replace(/Id$/, "Name");
export const multiLevelRouteField = (field: string) => field.replace(/Id$/, "Route");

// eslint-disable-next-line complexity,max-lines-per-function
export const parseAdDetailValue = (
  attribute: AttributeI,
  adValue: any,
  groupType: string,
  ad: any = {}
) => {
  let value = null;
  if (isAllowedValue(adValue) && adValue != emptyUUID) {
    if (groupType === DetailGroupType.valueWithTitle) {
      switch (attribute.type) {
        case DetailValueType.singleOption: {
          const option = attribute.options.find(
            ({ value: optionValue }) => optionValue === adValue
          );

          // eslint-disable-next-line max-depth
          if (option && option.title) {
            value = option.title;
          }

          break;
        }

        case DetailValueType.multiOptions: {
          const titles = attribute.options
            .filter(option => adValue.includes(option.value))
            .map(option => option.title);

          // eslint-disable-next-line max-depth
          if (titles.length > 0) {
            value = joinWithTwoSeparators(titles);
          }

          break;
        }

        case DetailValueType.textList: {
          const items = Array.isArray(adValue)
            ? adValue.filter(item => isAllowedValue(item))
            : [adValue];

          // eslint-disable-next-line max-depth
          if (items.length > 0) {
            value = items.join(", ");
          }

          break;
        }

        case DetailValueType.date:
          value = formatDate(adValue, config.dateFormat, true);
          break;

        case DetailValueType.monthYear:
          value = adValue === notRegistredOption.value ? notRegistredOption.title : formatDate(adValue, config.monthFormat, true);
          break;

        case DetailValueType.year:
          value = formatDate(adValue, config.yearFormat, true);
          break;

        case DetailValueType.time:
          // Format minutes to Croatian time format
          const minutes = parseInt(adValue, 10);
          if (!isNaN(minutes)) {
            const { formatMinutesToCroatian } = require("../utils/timeFormatter");
            value = formatMinutesToCroatian(minutes);
          } else {
            value = adValue;
          }
          break;

        case DetailValueType.multiLevel:
          // The name is returned with the ad (makeName, modelName, categoryLv1Name, ...)
          value = ad[multiLevelNameField(attribute.field)] || null;
          break;

        case DetailValueType.image:
          value = adValue[0];
          break;

        default:
          value = attribute.numberFormatted
            ? `${formatNumber(adValue)} ${attribute.unit}`
            : `${adValue} ${attribute.unit}`;
          break;
      }
    } else {
      value = adValue;
    }
  }

  return value;
};



// WEBPACK FOOTER //
// ./src/services/mutilevel.ts